import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

const generateGuestSessionId = () => `session_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;

interface AuthState {
    accessToken: string | null;
    refreshToken: string | null;
    consoleSessionId?: string;
    a_id?: string;
    a_name?: string;

    setAuth: (data: Partial<AuthState>) => void;
    clearAuth: () => void;
    logout: () => void;
}

const customStorage: PersistStorage<AuthState> = {
    getItem: name => {
        const item = localStorage.getItem(name);
        return item ? JSON.parse(item) : null;
    },
    setItem: (name, value) => {
        localStorage.setItem(name, JSON.stringify(value));
    },
    removeItem: name => {
        localStorage.removeItem(name);
    },
};

export const useConsoleAuthStore = create(
    persist<AuthState>(
        (set, get) => {
            const existingGuestSessionId = typeof window !== "undefined" && localStorage.getItem("console_session_id");

            const newConsoleSessionId = existingGuestSessionId || generateGuestSessionId();

            if (!existingGuestSessionId && typeof window !== "undefined") {
                localStorage.setItem("console_session_id", newConsoleSessionId);
            }

            return {
                accessToken: null,
                refreshToken: null,
                consoleSessionId: newConsoleSessionId,

                setAuth: data => set(state => ({ ...state, ...data })),

                clearAuth: () => {
                    customStorage.removeItem("console-auth-storage");
                    set({
                        accessToken: null,
                        refreshToken: null,
                        consoleSessionId: get().consoleSessionId,
                        a_id: undefined,
                        a_name: undefined,
                    });
                },

                logout: () =>
                    set(state => ({
                        ...state,
                        accessToken: null,
                        refreshToken: null,
                    })),
            };
        },
        {
            name: "console-auth-storage",
            storage: customStorage,
        },
    ),
);
